import { format } from 'date-fns'
import { parseLocalDate } from '@/lib/dashboard-next-up'
import { WARRANTY_ATTENTION_DAYS, warrantyDaysLeft, type OverviewItem } from '@/lib/items-overview'

/** Today as YYYY-MM-DD in the device's timezone. */
export function deviceToday(): string {
  return format(new Date(), 'yyyy-MM-dd')
}

/** "today", "tomorrow", "in 9 days", "in 3 weeks". */
export function warrantyCountdown(days: number): string {
  if (days === 0) return 'today'
  if (days === 1) return 'tomorrow'
  if (days < 14) return `in ${days} days`
  return `in ${Math.round(days / 7)} weeks`
}

export function formatWarrantyDate(warrantyExpiry: string, withYear = false): string {
  return format(parseLocalDate(warrantyExpiry), withYear ? 'MMM d, yyyy' : 'MMM d')
}

/**
 * Second line of an item row or tile. A warranty ending soon replaces the usual
 * details, so the one thing that needs attention is the thing you read.
 */
export function itemSubtitle(
  item: OverviewItem,
  today: string,
  { showRoom, showPurchase = true }: { showRoom: boolean; showPurchase?: boolean }
): { text: string; warn: boolean } {
  const days = warrantyDaysLeft(item.warrantyExpiry, today)
  if (days !== null && days <= WARRANTY_ATTENTION_DAYS) {
    return { text: `Warranty ends ${formatWarrantyDate(item.warrantyExpiry!)}`, warn: true }
  }

  const room = showRoom ? item.location?.trim() : null
  // Skip the category when it just repeats the room ("Kitchen, Kitchen").
  const parts = [room, room?.toLowerCase() === item.category.toLowerCase() ? null : item.category]
  if (showPurchase && item.purchaseDate) parts.push(`bought ${parseLocalDate(item.purchaseDate).getFullYear()}`)
  return { text: parts.filter(Boolean).join(', '), warn: false }
}
